export default class IPAddress {
    public static get(headers:  Readonly<Record<string, string>>): string | null {
        const ipAddress: string | null = headers["x-client-ip"] || headers["x-forwarded-for"] || headers["cf-connecting-ip"] || headers["fastly-client-ip"] || headers["true-client-ip"] || headers["x-real-ip"] || headers["x-cluster-client-ip"]
        || headers["x-forwarded"] || headers["forwarded-for"] || headers["forwarded"] || headers["appengine-user-ip"] || headers["req.connection.remoteAddress"] || headers["req.socket.remoteAddress"]
        || headers["req.connection.socket.remoteAddress"] || headers["req.info.remoteAddress"] || headers["cf-pseudo-ipv4"] || headers["request.raw"];
        if (ipAddress)
            return ipAddress.split(",")[0].trim();
        return null;
    }
}
